import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createSlots as _createSlots, createBlock as _createBlock, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/logo.png';
import _imports_1 from '@/assets/images/collapse_a.svg';
import _imports_2 from '@/assets/images/collapse.svg';
import _imports_3 from '@/assets/images/icons/new.png';
import _imports_4 from '@/assets/images/icons/more.png';
import _imports_5 from '@/assets/images/icons/ls.png';
import _imports_6 from '@/assets/images/handle/more.png';
const _hoisted_1 = { class: "sidebar flexColumn bgImage" };
const _hoisted_2 = { class: "s_head flexRow-alc flex-jcsb" };
const _hoisted_3 = { class: "flexRow-alc" };
const _hoisted_4 = {
    key: 0,
    class: "ft16",
    style: { "margin-right": "10px" }
};
const _hoisted_5 = {
    key: 0,
    src: _imports_1,
    style: { "width": "24px", "height": "24px" }
};
const _hoisted_6 = {
    key: 1,
    src: _imports_2,
    style: { "width": "24px", "height": "24px" }
};
const _hoisted_7 = { class: "flex1 s_main" };
const _hoisted_8 = { class: "flexRow-alc flex1" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "ft14" };
const _hoisted_11 = { class: "childrens" };
const _hoisted_12 = { class: "ft14" };
const _hoisted_13 = { class: "childrens" };
const _hoisted_14 = { class: "flexRow-alc flex-jcsb oneBeyond flex1" };
const _hoisted_15 = { class: "oneBeyond flex1" };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
    key: 0,
    style: { "height": "80px" }
};
import config from '@/api/config';
import { reactive, computed, ref, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import emitter from '@/utils/eventBus';
import ycHandle from '@/components/yc-handle/yc-handle.vue';
import feedback from '@/utils/feedback';
export default /*@__PURE__*/ _defineComponent({
    __name: 'sidebar',
    setup(__props) {
        onMounted(() => {
            emitter.on('intelligenceSwtich', () => {
                emitter.emit('goIntelligence', intelligenceItem.value);
                initIntelligence(intelligenceItem.value);
            });
        });
        onUnmounted(() => {
            emitter.off('intelligenceSwtich');
        });
        const route = useRoute();
        const router = useRouter();
        const elMenuRef = ref();
        const defaultOpeneds = ref(['home', 'openChild', 'more']);
        const activeMenu = computed(() => {
            var _a;
            if ((_a = route === null || route === void 0 ? void 0 : route.meta) === null || _a === void 0 ? void 0 : _a.type) {
                return route.meta.type;
            }
            return decodeURIComponent(String(route.fullPath));
        });
        const store = useStore();
        const isCollapse = computed(() => {
            return store.state.isMobile ? false : store.state.isCollapse;
        });
        const handleCollapse = (val = false) => {
            store.commit('handleCollapse', val || false);
        };
        // 智能体历史
        const intelligenceHistory = computed(() => store.state.intelligence.historyList || []);
        const intelligenceItem = ref();
        const getIntelligenceUrl = (item) => {
            return `/intelligence_chat?id=${item.modelId}&name=${encodeURIComponent(item.modelName)}&historyId=${item.id}`;
        };
        const goIntelligence = async (item) => {
            intelligenceItem.value = item;
            if (route.name == '/intelligence_chat') {
                if (store.state.intelligenceStatus)
                    return;
                emitter.emit('goIntelligence', item);
            }
            initIntelligence(item);
        };
        const initIntelligence = (item) => {
            let url = getIntelligenceUrl(item);
            openHandle2(-1);
            router.push(url);
        };
        const getImage = (icon) => {
            return require(`@/assets/images/icons/` + icon);
        };
        const getPath = (item) => {
            // if (item?.modelType == 9) return `/tabulation?id=${item?.data?.id}`
            // if (item?.modelType == 3 || item?.modelType == 5) return `/deepseek?id=${item?.data?.id}`;
            // if (item.modelName == 'drawing') return `/drawing_chat?chatid=${item?.data?.id}&viewType=${item.modelName}`
            // if (item.modelType == 6) return `/imagecomprehend?historyId=${item?.data?.id}`
            // return `/chat?chatid=${item?.data?.id}&viewType=${feedback.getViewType(item?.data)}`
            return feedback.getRouteJump(item === null || item === void 0 ? void 0 : item.categoryCode, item === null || item === void 0 ? void 0 : item.data);
        };
        const jumpVerify = (routePath, routeType = '') => {
            handleCollapse();
            if (store.state.chatStatus) {
                if (routePath == '/tabulation' && route.name === '/tabulation') {
                    store.commit('setSidebarJump', '/tabulation');
                    return;
                }
                if (routePath == '/deepseek' && route.name === '/deepseek') {
                    store.commit('setSidebarJump', '/deepseek');
                    return;
                }
                if (routePath == '/nineHeavens' && route.name === '/nineHeavens') {
                    store.commit('setSidebarJump', '/nineHeavens');
                    return;
                }
            }
            else {
                if (routePath == route.name && routeType)
                    return router.replace(routePath);
                if (routePath !== route.name) {
                    router.push(routePath);
                }
                else {
                    emitter.emit('jumpInit', {});
                }
            }
        };
        const jump = async (routePath) => {
            handleCollapse();
            if (routePath === route.fullPath)
                return;
            router.push(routePath);
        };
        const lists = reactive([
            {
                name: 'AI写作',
                icon: 'xz.png',
                routePath: '/writing',
                type: 'writing'
            },
            {
                name: 'PPT生成',
                icon: 'ppt.png',
                routePath: '/pptMake',
                type: 'ppt'
            },
            {
                name: 'AI会议',
                icon: 'hy.png',
                routePath: '/meeting/introduce',
                type: 'meeting'
            }
        ]);
        const moreLists = reactive([
            {
                name: 'AI表格',
                icon: 'bg.png',
                routePath: '/tabulation'
            },
            {
                name: '同声传译',
                icon: 'tscy.png',
                routePath: '/simultaneousTranslation/introduce',
                type: 'simultaneousTranslation'
            },
            {
                name: 'AI绘画',
                icon: 'draw.png',
                routePath: '/drawing',
                type: 'drawing'
            },
            {
                name: 'AI语音通话',
                icon: '',
                routePath: '/voicecall'
            },
            {
                name: '智能体',
                icon: '',
                routePath: '/intelligence_list'
            }
        ]);
        const histroyList = computed(() => {
            var _a;
            let datas = Array.isArray((_a = store.state) === null || _a === void 0 ? void 0 : _a.histroyList) ? JSON.parse(JSON.stringify(store.state.histroyList)) : [];
            // 截取前 4 个元素
            return datas.length > 0 ? datas.slice(0, 4) : [];
        });
        const historyChange = async (item) => {
            handleCollapse();
            store.commit('setHistroySelect', {
                ...item === null || item === void 0 ? void 0 : item.data,
                categoryCode: (item === null || item === void 0 ? void 0 : item.categoryCode) || '',
            });
            if (!store.state.chatStatus) {
                feedback.getRouteJump(item === null || item === void 0 ? void 0 : item.categoryCode, item === null || item === void 0 ? void 0 : item.data, {
                    isJump: true,
                    routePath: String(route.name)
                });
            }
            openHandle(-1);
        };
        const handleIndex = ref(-1);
        const ycHandleRef = ref();
        const openHandle = (index) => {
            var _a;
            // 重复点击关闭
            if (handleIndex.value == index && handleIndex.value !== -1) {
                (_a = ycHandleRef.value[handleIndex.value]) === null || _a === void 0 ? void 0 : _a.close();
                handleIndex.value = -1;
                return;
            }
            // 显示选择，其他关闭
            ycHandleRef.value.forEach((el, ind) => {
                if (ind == index) {
                    el.open();
                }
                else {
                    el.close();
                }
            });
            // 拷贝上次选择
            handleIndex.value = index;
        };
        const handleIndex2 = ref(-1);
        const ycHandleRef2 = ref();
        const openHandle2 = (index) => {
            var _a;
            // 重复点击关闭
            if (handleIndex2.value == index && handleIndex2.value !== -1) {
                (_a = ycHandleRef2.value[handleIndex2.value]) === null || _a === void 0 ? void 0 : _a.close();
                handleIndex2.value = -1;
                return;
            }
            // 显示选择，其他关闭
            ycHandleRef2.value.forEach((el, ind) => {
                if (ind == index) {
                    el.open();
                }
                else {
                    el.close();
                }
            });
            // 拷贝上次选择
            handleIndex2.value = index;
        };
        return (_ctx, _cache) => {
            const _component_el_menu_item = _resolveComponent("el-menu-item");
            const _component_el_sub_menu = _resolveComponent("el-sub-menu");
            const _component_el_menu = _resolveComponent("el-menu");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("aside", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[5] || (_cache[5] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                        (!isCollapse.value)
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_unref(config).brand_name), 1))
                            : _createCommentVNode("", true)
                    ]),
                    (!isCollapse.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "clickable",
                            onClick: _cache[0] || (_cache[0] = ($event) => (handleCollapse(!_unref(store).state.isCollapse)))
                        }, [
                            (_unref(store).state.isMobile)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                                : (_openBlock(), _createElementBlock("img", _hoisted_6))
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("aside", _hoisted_7, [
                    _createVNode(_component_el_menu, {
                        ref_key: "elMenuRef",
                        ref: elMenuRef,
                        "default-active": activeMenu.value,
                        router: "",
                        collapse: isCollapse.value,
                        "default-openeds": defaultOpeneds.value
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_el_menu_item, {
                                index: "/new-chat",
                                onClick: _cache[1] || (_cache[1] = ($event) => (jumpVerify('/new-chat')))
                            }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createElementVNode("div", { class: "flexRow-alc" }, [
                                        _createElementVNode("img", {
                                            src: _imports_3,
                                            class: "icons"
                                        }),
                                        _createElementVNode("span", { class: "ft14" }, "新对话")
                                    ], -1)
                                ])),
                                _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                    index: item.type || item.routePath,
                                    key: index,
                                    onClick: ($event) => (jumpVerify(item.routePath, item.type)),
                                    style: _normalizeStyle({ marginBottom: lists.length - 1 === index ? '0' : '8px' })
                                }, _createSlots({
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("img", {
                                                src: getImage(item.icon),
                                                class: "icons"
                                            }, null, 8, _hoisted_9),
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.name), 1)
                                        ])
                                    ]),
                                    _: 2
                                }, [
                                    (isCollapse.value)
                                        ? {
                                            name: "title",
                                            fn: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.name), 1)
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032, ["index", "onClick", "style"]));
                            }), 128)),
                            _createVNode(_component_el_sub_menu, { index: "more" }, {
                                title: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createElementVNode("div", { class: "flexRow-alc" }, [
                                        _createElementVNode("img", {
                                            src: _imports_4,
                                            class: "icons"
                                        }),
                                        _createElementVNode("span", { class: "ft14" }, "更多")
                                    ], -1)
                                ])),
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moreLists, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                index: item.type || item.routePath,
                                                key: index,
                                                onClick: ($event) => (jumpVerify(item.routePath, item.type))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("p", _hoisted_12, _toDisplayString(item.name), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["index", "onClick"]));
                                        }), 128))
                                    ])
                                ]),
                                _: 1
                            }),
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "line" }, null, -1)),
                            _createVNode(_component_el_sub_menu, { index: "openChild" }, {
                                title: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createElementVNode("div", { class: "flexRow-alc" }, [
                                        _createElementVNode("img", {
                                            src: _imports_5,
                                            class: "icons"
                                        }),
                                        _createElementVNode("span", { class: "ft14" }, "历史对话")
                                    ], -1)
                                ])),
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_13, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(histroyList.value, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                index: getPath(item),
                                                key: index,
                                                onClick: ($event) => (historyChange(item))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_14, [
                                                        _createElementVNode("p", _hoisted_15, _toDisplayString((item && item.data) && item.data.title || '-'), 1),
                                                        _createVNode(ycHandle, {
                                                            ref_for: true,
                                                            ref_key: "ycHandleRef",
                                                            ref: ycHandleRef,
                                                            datas: item,
                                                            onClose: _cache[2] || (_cache[2] = ($event) => (handleIndex.value = -1)),
                                                            onInit: _cache[3] || (_cache[3] = ($event) => (_unref(router).push('/')))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _withDirectives(_createElementVNode("div", {
                                                                    class: "flexRow-alc si_del",
                                                                    onClick: _withModifiers(($event) => (openHandle(index)), ["stop"])
                                                                }, _cache[9] || (_cache[9] = [
                                                                    _createElementVNode("img", { src: _imports_6 }, null, -1)
                                                                ]), 8, _hoisted_16), [
                                                                    [_vShow, activeMenu.value === getPath(item)]
                                                                ])
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["datas"])
                                                    ])
                                                ]),
                                                _: 2
                                            }, 1032, ["index", "onClick"]));
                                        }), 128)),
                                        _createVNode(_component_el_menu_item, {
                                            index: "/history-chat",
                                            onClick: _cache[4] || (_cache[4] = ($event) => (jump('/history-chat')))
                                        }, {
                                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                _createElementVNode("p", null, "查看全部", -1)
                                            ])),
                                            _: 1
                                        })
                                    ]),
                                    (!_unref(store).state.isMobile && _unref(store).state.isPad)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["default-active", "collapse", "default-openeds"])
                ])
            ]));
        };
    }
});
